module.exports = __webpack_public_path__ + "img/kr-bg-top-right.282e8fa.png";